import type ThemeInterface from '@/theme-interface'

export const getMjmlButtonEditorStyles = (theme: ThemeInterface) => ({
  // Base MJML button styles for the editor
  '& [data-mjml-button]': {
    display: 'block !important',
    padding: '10px 20px',
    margin: '5px 0',
    border: `1px solid ${theme.primary}`,
    color: theme.primary,
    borderRadius: theme.borderRadius,
    textDecoration: 'none !important',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    minWidth: '100px',
    position: 'relative',
    backgroundColor: 'transparent',
    userSelect: 'none',

    '&:hover': {
      opacity: 0.9,
      transform: 'translateY(-1px)',
      boxShadow: `0 2px 4px ${theme.primary}20`,
    },

    '&:active': {
      transform: 'translateY(0)',
    },

    // Focus styles for accessibility
    '&:focus': {
      outline: `2px solid ${theme.primary}`,
      outlineOffset: '2px',
    },
  },

  // Selection styles when the node is selected
  '& .ProseMirror-selectednode [data-mjml-button]': {
    outline: `2px dashed ${theme.primary}`,
    outlineOffset: '2px',
  },
})
